import { render } from "./FloatingSaveCancel.vue?vue&type=template&id=fba48a98&scoped=true"
import script from "./FloatingSaveCancel.vue?vue&type=script&lang=js"
export * from "./FloatingSaveCancel.vue?vue&type=script&lang=js"

import "./FloatingSaveCancel.vue?vue&type=style&index=0&id=fba48a98&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba48a98"]])

export default __exports__